// Use caution. This file is modified by docker/prepare.sh during the prod build.
//
// In prod, prepare.sh sed-replaces the four `baked_*` lines below.
// In dev (CRA dev server), the `baked_*` lines stay empty and the
// REACT_APP_* env vars take precedence — so the dev container can pick up
// values from frontend-stack.devel.yaml without rewriting source files.
import {getItem} from './storage.js';

function getCanonicalHost(hostname) {
  const MAX_TLD_LENGTH = 3;

  function isNotTLD(_) { return _.length > MAX_TLD_LENGTH; };

  hostname = hostname.split('.');
  hostname = hostname.slice(Math.max(0, hostname.findLastIndex(isNotTLD)));
  hostname = hostname.join('.');

  return hostname;
}

function get_stage(hostname) {
  const regex = /-(.+?)(?:\..*\..*$)/;
  const match = hostname.match(regex);

  if (match) {
    const extractedString = match[1];
    return '-' + extractedString;
  } else {
    return "";
  }
}

const WHITELABEL_DOMAINS = ["cloudworkstations.com", "go2cloud.app"]


export const web_entrypoint = '';

// --- Baked constants (populated by docker/prepare.sh in prod) ---------------
const baked_web_api_entrypoint_template = '';
const baked_oauth_client_id = '';
const baked_flagsmith_proxy_hostname = '';
const baked_flagsmith_client_key = '';

// --- Resolved values: env var (dev) wins, baked (prod) fallback ------------
const __web_api_entrypoint_template =
    process.env.REACT_APP_API_ENDPOINT_TEMPLATE || baked_web_api_entrypoint_template;
const __oauth_client_id =
    process.env.REACT_APP_OAUTH_CLIENT_ID || baked_oauth_client_id;
const __flagsmith_external_proxy_hostname =
    process.env.REACT_APP_FLAGSMITH_PROXY_HOSTNAME || baked_flagsmith_proxy_hostname;
const __flagsmith_client_side_environment_key =
    process.env.REACT_APP_FLAGSMITH_CLIENT_KEY || baked_flagsmith_client_key;

let __web_api_entrypoint;
let __is_whitelabel;

if(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  // On the Electron version
  __web_api_entrypoint = '';
  __is_whitelabel = false || getItem('is_whitelabel_override');
}
else {
  // On the browser version
  const canonical_domain = getCanonicalHost(window.location.hostname)
  const current_stage = get_stage(window.location.hostname)
  __web_api_entrypoint = __web_api_entrypoint_template
      .replace('DYNAMIC_DOMAIN_FROM_URL_TAG', canonical_domain)
      .replace('DYNAMIC_STAGE_FROM_URL_TAG', current_stage);

  if (window.location.hostname.startsWith('new')) {
    __web_api_entrypoint = __web_api_entrypoint.replace(/(http:\/\/|https:\/\/)/, "$&new");
  }
  __is_whitelabel = WHITELABEL_DOMAINS.indexOf(canonical_domain) >= 0 || window.location.search.indexOf('wl') >= 0
}

export const is_whitelabel = __is_whitelabel;
export const web_api_entrypoint = __web_api_entrypoint;
export const oauth_client_id = __oauth_client_id;

export const flagsmith_external_proxy_hostname = __flagsmith_external_proxy_hostname;
export const flagsmith_client_side_environment_key = __flagsmith_client_side_environment_key;



